import { Link, useNavigate } from "react-router-dom"

import { useAuthenticationDispatchContext } from "@l2r-front/l2r-auth"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { LogoutIcon, SettingsIcon } from "@l2r-front/l2r-icons"
import { useBlockingNavigate } from "@l2r-front/l2r-query"
import { L2RMenu } from "@l2r-front/l2r-ui"
import { useUrlParams } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../constants/i18n"

export const AccountMenu = (props) => {
    const {
        anchorEl,
        onClose,
        open,
        ...menuProps
    } = props

    const { t } = useTranslation([I18N_NAMESPACE])
    const { getParams } = useUrlParams()
    const searchParams = getParams()
    const navigate = useNavigate()
    const { logout } = useAuthenticationDispatchContext()
    const blockingNavigate = useBlockingNavigate(() => navigate("/"), logout)

    return (
        <L2RMenu
            anchorEl={anchorEl}
            onClose={onClose}
            open={open}
            menuConfig={[
                {
                    id: "account-settings",
                    label: t(I18N_NAMESPACE, "containers.accountMenu.settings"),
                    icon: <SettingsIcon color="objects/object-primary" />,
                    props: {
                        component: Link,
                        state: { internal: true },
                        to: `/account_settings?${searchParams}`,
                    },
                },
                {
                    id: "logout-button",
                    label: t(I18N_NAMESPACE, "containers.accountMenu.logout"),
                    icon: <LogoutIcon color="objects/object-primary" />,
                    props: {
                        onClick: blockingNavigate,
                    },
                },
            ]}
            {...menuProps} />
    )
}

AccountMenu.propTypes = {
    ...L2RMenu.propTypes,
}